(() => {
  if (customElements.get('footer-cta-motion')) return;
  customElements.define('footer-cta-motion', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.card = this.querySelector('.agency-footer-cta__card');
      if (!this.card) return;
      this.media = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference) and (forced-colors: none)');
      const reset = () => this.reset();
      const track = (event) => {
        if (event.pointerType !== 'mouse' || !this.media.matches) return;
        if (!this.classList.contains('is-glare-active')) {
          this.classList.add('is-glare-active');
          this.timer = setTimeout(() => this.classList.add('is-glare-tracking'), 300);
        }
        this.pointer = { x: event.clientX, y: event.clientY };
        if (this.frame != null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.isConnected || !this.media.matches || !this.pointer) return this.reset();
          // Use the stationary wrapper so the card cannot move its own hover target.
          const rect = this.getBoundingClientRect();
          if (!rect.width || !rect.height) return this.reset();
          const x = Math.max(0, Math.min(100, (this.pointer.x - rect.left) / rect.width * 100));
          const y = Math.max(0, Math.min(100, (this.pointer.y - rect.top) / rect.height * 100));
          const values = { x: `${x}%`, y: `${y}%`, 'bg-x': `${37.5 + x / 4}%`, 'bg-y': `${33.333333 + y / 3}%`, 'rotate-x': `${(y - 50) * .024}deg`, 'rotate-y': `${(x - 50) * -.016}deg` };
          Object.entries(values).forEach(([key, value]) => this.card.style.setProperty(`--agency-glare-${key}`, value));
        });
      };
      this.addEventListener('pointerenter', track, { signal });
      this.addEventListener('pointermove', track, { signal });
      ['pointerleave', 'pointercancel', 'focusin'].forEach(event => this.addEventListener(event, reset, { signal }));
      ['blur', 'resize', 'scroll'].forEach(event => window.addEventListener(event, reset, { signal, passive: true }));
      this.media.addEventListener('change', reset, { signal });
      document.addEventListener('visibilitychange', reset, { signal });
    }
    reset() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.frame = null;
      this.pointer = null;
      this.classList.remove('is-glare-active', 'is-glare-tracking');
      ['x', 'y', 'bg-x', 'bg-y', 'rotate-x', 'rotate-y'].forEach(key => this.card?.style.removeProperty(`--agency-glare-${key}`));
    }
    disconnectedCallback() { this.reset(); this.controller?.abort(); }
  });
})();
